<script>
const appOptions = {
    appSidebarMinified: false,
    appSidebarNone: false,
    appSidebarEnd: false,
    appSidebarTwo: false,
    appSidebarWide: false,
    appSidebarLight: false,
    appSidebarTransparent: false,
    appSidebarMobileToggled: false,
    appSidebarEndMobileToggled: false,
    appSidebarEndToggled: false,
    appSidebarEndCollapsed: false,
    appSidebarSearch: true,
    appContentFullHeight: false,
    appContentClass: false,
    appHeaderLanguageBar: true,
    appHeaderInverse: false,
    appHeaderMegaMenu: false,
    appHeaderMegaMenuMobileToggled: false,
    appTopMenu: false,
    appTopMenuMobileToggled: false,
    appEmpty: false,
    appBodyScrollTop: 0
}

export default appOptions;
</script>
